<script setup>
import { ref } from "vue";

defineProps({
  refer: {
    type: String,
    required: true,
  },
  miniIcon: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
});

const isExpanded = ref(false);

const handleClick = () => {
  isExpanded.value = !isExpanded.value;
};

defineExpose({
  isExpanded
});
</script>
<template>
  <li class="nav-item">
    <a
      class="nav-link ms-3"
      data-bs-toggle="collapse"
      aria-expanded="false"
      :href="`#${refer}`"
      @click="handleClick"
    >
      <span class="sidenav-mini-icon"> {{ miniIcon }} </span>
      <span class="sidenav-normal"> {{ text }} <b class="caret"></b></span>
    </a>
     <div :id="refer" :class="isExpanded ? 'collapse show' : 'collapse'">
      <ul class="nav nav-sm flex-column">
        <slot name="nav-child-item" />
      </ul>
    </div>
  </li>
</template>
